<app-dialog [dialogWithInput]="dialog">
    <app-create-update-default
        #createUpdateDefaultComponent
        (entityLoaded)="entityLoaded($event)"
        (entitySaved)="entitySaved($event)"
        [buildPayload]="buildPayload"
        [formGroup]="formGroup"
        [id]="dialog.input.id"
        [inDialog]="true"
        [service]="service"
        [findOneService]="findOneService"
        [hideSaveButton]="true">
        <ng-template template-content>
            <div class="row">
                <div class="col-12">
                    <app-card-v2 title="Général">
                        <div class="row">
                            <app-form-field label="Localisation" [size]="12">
                                <app-lov-value-chips-autocomplete
                                        lovListName="MEDICAL_RECORD_PAIN_WHERE"
                                        [parentFormGroup]="formGroup"
                                        parentFormControlName="locations">
                                </app-lov-value-chips-autocomplete>
                            </app-form-field>

                            <app-form-field label="Quand?" [size]="12">
                                <app-lov-value-chips-autocomplete
                                        lovListName="MEDICAL_RECORD_PAIN_WHEN"
                                        [parentFormGroup]="formGroup"
                                        parentFormControlName="whens">
                                </app-lov-value-chips-autocomplete>
                            </app-form-field>

                            <app-form-field label="Comment?" [size]="12">
                                <app-lov-value-chips-autocomplete
                                        lovListName="MEDICAL_RECORD_PAIN_HOW"
                                        [parentFormGroup]="formGroup"
                                        parentFormControlName="hows">
                                </app-lov-value-chips-autocomplete>
                            </app-form-field>
                        </div>
                        <div class="row">
                            <app-form-field label="Date de la première perception de la douleur" size="12" sizeLg="9"
                                            sizeXl="9">
                                <app-custom-date-input #from [parentFormGroup]="fromFormGroup"
                                                       style="width: 100%;"></app-custom-date-input>
                            </app-form-field>
                            <app-form-field label="La douleur est toujours perçue" size="12" sizeLg="3"
                                            sizeXl="3">
                                <app-checkbox-input [parentFormGroup]="formGroup"
                                                    parentFormControlName="painStillHere"
                                                    (changeEvent)="synchronizePainStillHereControl()"></app-checkbox-input>
                            </app-form-field>
                        </div>
                        <div class="row" *ngIf="toFormGroup">
                            <app-form-field
                                    label="Date de la dernière perception de la douleur" size="12" sizeLg="9"
                                    sizeXl="9">
                                <app-custom-date-input #to
                                                       [parentFormGroup]="toFormGroup"
                                                       [initialDate]="toInitialDate"
                                                       [initialTypeValue]="toInitialTypeValue"
                                                       style="width: 100%;"></app-custom-date-input>
                            </app-form-field>
                        </div>
                    </app-card-v2>
                </div>
                <div class="col-12">
                    <app-card-v2 title="Intensités de la douleur">
                        <div class="row">
                            <div class="col-12">
                                <app-form-array-input *ngIf="formGroup.get('intensities')"
                                                      [maxElementSize]="1"
                                                      [buildNewItemForm]="newItemFormGroup"
                                                      [parentFormGroup]="formGroup"
                                                      addItemLabel="Définir une intensité"
                                                      parentFormControlName="intensities">
                                    <ng-template let-itemFormGroup='itemFormGroup' template-content>
                                        <form [formGroup]="itemFormGroup">
                                            <div class="row">
                                                <app-form-field label="Date" [required]="true" sizeLg="6" sizeXl="6">
                                                    <app-date-picker [parentFormGroup]="itemFormGroup"
                                                                     parentFormControlName="date"
                                                                     style="width: 100%;"></app-date-picker>
                                                </app-form-field>
                                                <app-form-field label="Intensité" [required]="true" sizeLg="6" sizeXl="6">
                                                    <mat-slider
                                                            [displayWith]="formatLabel"
                                                            aria-label="units"
                                                            [discrete]="true"
                                                            max="10"
                                                            min="0"
                                                            step="1"
                                                            style="width: 100%;"
                                                            thumbLabel
                                                            tickInterval="1">
                                                        <input matSliderThumb formControlName="intensity">
                                                    </mat-slider>
                                                </app-form-field>
                                            </div>
                                            <div class="row">
                                                <app-form-field label="Commentaire" sizeXl="12">
                                                    <app-rich-text-editor [parentFormGroup]="itemFormGroup" parentFormControlName="comment"></app-rich-text-editor>
                                                </app-form-field>
                                            </div>
                                        </form>
                                    </ng-template>
                                </app-form-array-input>
                            </div>
                            <div class="col-12" *ngIf="pain">
                                <div class="text-center" *ngIf="!pain?.lastIntensity">Aucune intensité</div>
                                <app-item *ngFor="let intensity of pain.intensities" [entity]="intensity">
                                    <app-summary>
                                        <ng-container content>
                                            <app-date-summary-field *ngIf="intensity.date" [date]="intensity.date"></app-date-summary-field>
                                            <app-summary-field [value]="intensity.intensity + '/10'"></app-summary-field>
                                        </ng-container>
                                    </app-summary>
                                    <app-button buttons iconName="x" [loading]="deleteIntensityService.loading$ | async" tooltip="Supprimer" (clickEvent)="deleteIntensity(intensity)"></app-button>
                                </app-item>
                            </div>
                        </div>
                    </app-card-v2>
                </div>
                <div class="col-12">
                    <app-card-v2 title="Commentaire">
                        <div class="row">
                            <app-form-field size="12">
                                <app-rich-text-editor [audioTranscriptionConfig]="audioTranscriptionConfig" [parentFormGroup]="formGroup" parentFormControlName="comment"></app-rich-text-editor>
                            </app-form-field>
                        </div>
                    </app-card-v2>
                </div>
            </div>
        </ng-template>
    </app-create-update-default>
    <ng-container dialog-actions>
        <app-loading [loading]="createUpdateDefaultComponent.saveLoading" [showText]="false"></app-loading>
        <app-button (click)="executeSave()" [disabled]="!formGroup.valid" fill="solid" color="primary"
                    iconName="check" label="Enregistrer" *ngIf="!createUpdateDefaultComponent.saveLoading &&
                !createUpdateDefaultComponent.loading && !createUpdateDefaultComponent.findOneError"></app-button>
    </ng-container>
</app-dialog>
